var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7503 22.4997C41.8212 22.4997 43.5 20.8209 43.5 18.75C43.5 16.6791 41.8211 15.0003 39.7502 15.0003C37.6791 15.0003 36 16.6792 36 18.7503V22.4997H39.7503ZM29.25 22.4997C31.3211 22.4997 33 20.8207 33 18.7497V8.25031C33 6.17924 31.3211 4.50031 29.25 4.50031C27.1789 4.50031 25.5 6.17924 25.5 8.25031V18.7497C25.5 20.8207 27.1789 22.4997 29.25 22.4997Z",
    fill: "#2EB67D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24968 25.5003C6.17879 25.5003 4.5 27.1791 4.5 29.25C4.5 31.3209 6.17895 32.9997 8.24984 32.9997C10.3209 32.9997 12 31.3207 12 29.2497V25.5003H8.24968ZM18.75 25.5003C16.6789 25.5003 15 27.1793 15 29.2503V39.7497C15 41.8207 16.6789 43.4997 18.75 43.4997C20.8211 43.4997 22.5 41.8207 22.5 39.7497V29.2503C22.5 27.1793 20.8211 25.5003 18.75 25.5003Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5002 39.7503C25.5002 41.8212 27.1789 43.5 29.2498 43.5C31.3207 43.5 32.9995 41.8211 32.9995 39.7502C32.9995 37.6791 31.3206 36 29.2495 36L25.5002 36L25.5002 39.7503ZM25.5002 29.25C25.5002 31.3211 27.1791 33 29.2502 33L39.7495 33C41.8206 33 43.4995 31.3211 43.4995 29.25C43.4995 27.1789 41.8206 25.5 39.7495 25.5L29.2502 25.5C27.1791 25.5 25.5002 27.1789 25.5002 29.25Z",
    fill: "#ECB22E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4996 8.24968C22.4996 6.17879 20.8208 4.5 18.7499 4.5C16.679 4.5 15.0002 6.17895 15.0002 8.24984C15.0002 10.3209 16.6792 12 18.7502 12L22.4996 12L22.4996 8.24968ZM22.4996 18.75C22.4996 16.6789 20.8207 15 18.7496 15L8.25025 15C6.17918 15 4.50024 16.6789 4.50024 18.75C4.50024 20.8211 6.17918 22.5 8.25024 22.5L18.7496 22.5C20.8207 22.5 22.4996 20.8211 22.4996 18.75Z",
    fill: "#36C5F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.7eed76789a16a51e4d9f34fc3b4e5cd5.svg";
export { ForwardRef as ReactComponent };